<script setup lang="ts">
    import type { DialogTitleProps } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { DialogTitle, useForwardProps } from 'reka-ui';
    import { cn } from '../../utils';

    const props = defineProps<DialogTitleProps & { class?: HTMLAttributes['class'] }>();

    const delegatedProps = reactiveOmit(props, 'class');

    const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DialogTitle
        data-slot="dialog-title"
        v-bind="forwardedProps"
        as="div"
        :class="cn('text-2xl font-semibold', props.class)"
    >
        <slot />
    </DialogTitle>
</template>
